import { axiosInstance, MediaTypeEnum } from '../../utils';

export interface SearchCustomBrollsPaylod {
  name: string;
  type: string;
  page?: number;
  limit?: number;
}

export const searchCustomBrolls = async (payload: SearchCustomBrollsPaylod): Promise<any> => {
  const { name, page, limit, type } = payload;

  // Build the query parameters dynamically
  const queryParams = new URLSearchParams({
    ...(page && { pageSize: page.toString() }),
    ...(limit && { limit: limit.toString() }),
  });

  try {
    const res = await axiosInstance.post(
      `/api/broll/get-broll-media${queryParams?.toString() ? '?' + queryParams.toString() : ''}`,
      { name, type }
    );
    return res.data;
  } catch (error) {
    console.error('Error fetching custom brolls:', error);
    throw error;
  }
};
